export default __webpack_public_path__ + "static/media/do.25d9c6fa.png";